const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'BeBar',
  props: {
    data: {
      type: Array,
      default: () => [
        { id: 1, name: '站点1', value: 18, color: '' },
        { id: 2, name: '站点2', value: 85, color: '' },
        { id: 3, name: '站点3', value: 67, color: '' },
        { id: 4, name: '站点4', value: 32, color: '' },
        { id: 5, name: '站点5', value: 21, color: '' },
        { id: 6, name: '站点6', value: 45, color: '' },

        { id: 7, name: '站点7', value: 18, color: '' },
        { id: 8, name: '站点8', value: 85, color: '' },
        { id: 9, name: '站点9', value: 67, color: '' },
        { id: 10, name: '站点10', value: 32, color: '' },
        { id: 11, name: '站点11', value: 21, color: '' },
        { id: 12, name: '站点12', value: 45, color: '' },
        { id: 13, name: '站点13', value: 18, color: '' },
        { id: 14, name: '站点14', value: 85, color: '' },
        { id: 15, name: '站点15', value: 67, color: '' },
        { id: 16, name: '站点16', value: 32, color: '' },
        { id: 17, name: '站点17', value: 21, color: '' },
        { id: 18, name: '站点18', value: 45, color: '' },
        { id: 19, name: '站点19', value: 18, color: '' },
        { id: 20, name: '站点20', value: 85, color: '' },
        { id: 21, name: '站点21', value: 67, color: '' },
        { id: 22, name: '站点22', value: 32, color: '' },
        { id: 23, name: '站点23', value: 21, color: '' },
        { id: 24, name: '站点24', value: 45, color: '' },

      ]
    },
    type: { type: String, default: () => 'bar' },
    barWidth: { type: String | Number, default: () => '14' },
    cols: { type: String | Number, default: () => '' },
    grid: { type: Array, default: () => ['0', '0', '0', '0'] },
    color: { type: String, default: () => '#aaa' },
    fontSize: { type: String | Number, default: () => '12' },
    textStyle: { type: Object, default: () => ({}) },
    itemStyle: { type: Object, default: () => ({}) },
    scrollOption: { type: Object, default: () => ({ width: 20 }) },
    backgroundColor: { type: String, default: () => 'rgba(0, 0, 0, 0)' },
  },
  data() {
    return {
      option: {},
      styles: {
        textStyle: {
          color: this.color,
          fontSize: parseInt(this.fontSize),
          ...this.textStyle,
        },
      },
    }
  },
  watch: {
    data(next, prev) {
      if (JSON.stringify(next) != JSON.stringify(prev)) this.create();
    }
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      let max = 0;
      let data = this.data.sort((a, b) => {
        let prev = a.number || a.value || a.code || a.data || 0;
        let next = b.number || b.value || b.code || b.data || 0;
        if (next > max) max = next;
        return prev - next;
      });
      const labels = data.length > 0 && data.map(a => (a.name || a.label || a.title || '匿名'));
      const values = data.length > 0 && data.map((a, b) => ({
        name: a.name || a.text || a.label || a.title || '匿名',
        value: a.data || a.code || a.value || a.number || null,
        itemStyle: {
          color: a.color || null,
          borderWidth: a.borderWidth || 10,
          ...this.itemStyle,
        },
        animationDelay: c => c * b * 100,
        ...a,
      }));
      this.option = ({
        backgroundColor: this.backgroundColor,
        grid: {
          show: false,
          top: parseInt(this.grid[0]) || 0,
          right: parseInt(this.grid[1]) || 0,
          bottom: parseInt(this.grid[2] || this.grid[0]) || 0,
          left: parseInt(this.grid[3] || this.grid[1]) || 0,
          containLabel: true,
          ...this.styles,
        },
        // xAxis: { max: 'dataMax' },
        yAxis: {
          type: 'category',
          // max: 2, // only the largest 3 bars will be displayed
          // inverse: true,
          // animationDuration: 300,
          // animationDurationUpdate: 300,
          data: labels,
          axisLine: { show: true },
          splitLine: { show: false },
          splitArea: { show: false },
          axisLabel: {
            ...this.styles,
          },
        },
        // animationDuration: 0,
        // animationDurationUpdate: 3000,
        // animationEasing: 'linear',
        // animationEasingUpdate: 'linear',
        series: [
          {
            // name: '',
            type: 'bar',
            realtimeSort: true,
            barWidth: this.barWidth,
            label: { position: 'right', show: true, valueAnimation: true },
            itemStyle: { normal: { barBorderRadius: [0, 15, 15, 0] } }, // 柱形图圆角，初始化效果
            data: values,
          },
        ],
        // dataZoom: this.data.length > parseInt(this.cols) ? ([
        //   {
        //     show: true,
        //     yAxisIndex: [0],
        //     type: "slider",
        //     start,
        //     width: 12,
        //     filterMode: "empty",
        //     backgroundColor: "#1c355f",
        //     fillerColor: "#1a87e8",
        //     borderColor: "#1c355f",
        //     zoomLock: true,
        //   },
        //   {
        //     show: true,
        //     type: 'inside',
        //     yAxisIndex: [0],
        //     start,
        //     zoomOnMouseWheel: false,
        //     moveOnMouseMove: true,
        //     moveOnMouseWheel: true,
        //   }
        // ]) : null,
        dataZoom: this.cols && (this.data.length > parseInt(this.cols) && ([
          {
            show: true,
            type: 'slider',
            orient: 'vertical',
            yAxisIndex: [0],
            zoomLock: true,
            startValue: 100,
            maxValueSpan: (parseInt(this.cols) - 1),
            ...this.scrollOption
          },
          { type: 'inside', yAxisIndex: [0], zoomOnMouseWheel: false, moveOnMouseMove: true, moveOnMouseWheel: true },
        ])),
      });
    },
  },
  render() {
    const { option = {}, delay = 400, ...attrs } = this.$attrs;
    return (<Aecharts option={{ ...this.option, ...option }} delay={delay} {...{ attrs }} />);
  }
}